import api from "./core";

const basePath = "api/{{serverSegment}}/MarsRecords";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  FindAllFromEoc(id) {
    return api.get(`${basePath}/FromEoc/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  }
};
